import React from "react";
import { Helmet } from "react-helmet-async";
import { OG_IMAGE_TYPES, OGImage } from "../og-image";

const schema = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Used Car Valuation - Check Car Value for Free",
    "description": "Check your car’s value online with Cars24’s used car valuation calculator. We combine our largest dealer network and Smart AI Pricing Engine to track real-time market demand and offer you a great price for your car.",
    "publisher": {
        "@type": "Organization",
        "name": "Cars24"
    }
});

const SchemaUsedCarValuation = () => {
    return (
        <>
            <Helmet>
                <meta name="ROBOTS" content="INDEX,FOLLOW" />
            </Helmet>
            <Helmet script={[{

                type: "application/ld+json",
                innerHTML: schema
            }]} />
            <OGImage type={OG_IMAGE_TYPES.sellcar} />
        </>
    );
};

export default SchemaUsedCarValuation;
